import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

export default function Footer() {
  // Componente de enlace dinámico: usa Link de React Router si está disponible, si no, una etiqueta <a> normal.
  // Esto hace el componente más flexible. Si no usas React Router, puedes borrar esta línea
  // y usar la etiqueta <a> directamente en el JSX.
  const LinkComponent = typeof Link !== 'undefined' ? Link : 'a';

  const [appVersion, setAppVersion] = useState<string | null>(null);

  useEffect(() => {
    const meta  = document.querySelector('meta[name="version"]');
    if (meta) {
      const version = meta.getAttribute('content');
      setAppVersion(version);
    }
  }, [])


  return (
    <footer className="bg-gray-800 text-white shadow-md mt-6">
      <div className="max-w-7xl mx-auto py-1 px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col sm:flex-row justify-between items-center text-center sm:text-left">
          <p className="text-sm text-gray-400 mb-0 sm:mb-0">
            &copy; {new Date().getFullYear()} Tomarbus Ticket. Todos los derechos reservados.
          </p>
          <p className="text-sm text-gray-400 mb-2 sm:mb-0">Versión {appVersion}</p>
          <nav>
            <LinkComponent
              to="/terminos-y-condiciones" // Para React Router
              className="text-sm text-gray-300 hover:text-white hover:underline transition-colors duration-300"
            >
              Términos y Condiciones
            </LinkComponent>
            <span className="text-gray-500"> | </span>
            <LinkComponent
              to="/privacidad" // Para React Router
              className="text-sm text-gray-300 hover:text-white hover:underline transition-colors duration-300"
            >
              Política de Privacidad
            </LinkComponent>
          </nav>
        </div>
      </div>
    </footer>
  );
};
